export default __webpack_public_path__ + "static/media/therapist-2.42fa4dc8.svg";